<!-- 设备详情 -->
<template>
    <div class="content" :style="{ overflow: (showMpdal ? 'hidden' : 'auto') }">
        <div class="equipm xrow ai-c jc-sb" v-cloak>
            <div class="equipm-desc flex2">
                <div class="encoder-bg" :class="Encoder.InternalModel"></div>
                <div class="equ-cc">
                    <h3>农时农情农事观测站</h3>
                    <p>
                        <span>型号：{{ model }}</span>
                        <span>编码：{{ type }}</span>
                        <span>名称：{{ name }}</span>
                    </p>
                </div>
            </div>
            <div class="equipm-status flex3 mgl30 xrow ai-c jc-s pdh20">
                <div class="equ-net pdh20">
                    <i>
                        <el-image :src="require('../../../assets/status/run.png')" style="cursor:pointer;"
                            @click="showVideo"></el-image>
                    </i>
                    <b>播放</b>
                    <span>网络类型：4G</span>
                </div>
                <!-- <div class="equ-sensor xrow ai-c jc-c pdh20">
                    <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">影像监测</b><i class="mgt25"><img
                                src="../../../assets/category/sense-camera.png"></i><span
                            class="mgt20 color-m1f fs14">1个球机</span>
                    </div>
                </div> -->
                <div class="equ-alarm xrow ai-c- jc-s pdv20">
                    <div :class="[status ? '' : 'out-line', 'status', 'mgr10', 'pd30', 'xcol', 'ai-c', 'jc-sb', 'w140']">
                        <i><img src="../../../assets/status/ll-7.png"></i><span>{{ status
                            ? "在线" : "离线" }}</span>
                    </div>
                    <!-- <div class="alarm mgr10 pd30 xcol ai-c jc-sb w140">
                        <i>{{ AlarmCount }}</i><span>报警事件</span>
                    </div> -->
                    <div class="location pd30 xcol ai-c jc-sb w140">
                        <i><img src="../../../assets/status/ll-8.png"></i><span>{{ address }}</span><span
                            style="white-space: nowrap;margin-top: 5px;">{{
                                factory
                            }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="monitor mgt20">
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh20 mgt20 unselect">
                <div class="pl-title xrow ai-c jc-sb">
                    <div class="xrow ai-c">
                        <img src="../../../assets/category/sense-item-camera.png">
                        <span class="color-m09 fs20 lsp2 fw-bd mgl10">作物生长监控</span>
                    </div>
                    <!-- <div class="jc-c">
                        <el-form :inline="true" class="queryform">
                            <el-form-item label="显示方式" style="margin-bottom:0px;">
                                <el-select v-model="selectDayOption" placeholder="请选择">
                                    <el-option v-for="item in dayOptions" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                            </el-form-item>
                        </el-form>
                    </div> -->
                </div>
                <div class="pl-content">
                    <el-row>
                        <el-col :span="6" v-for="(image, index) in ImageList" :key="index">
                            <div class="mg10 image-item" @click="viewplant(image)">
                                <el-image :src="image.url" lazy fit="contain">
                                    <div slot="error" class="image-slot">
                                        加载失败
                                    </div>
                                    <div slot="placeholder">
                                        <img :src="require('../../../assets/default/0.png')"
                                            style="width:100%;height:100%;">
                                    </div>
                                </el-image>
                                <div class="desc pdv10">{{ image.receivedAt | dateFormat('yyyy-MM-dd') }}</div>
                            </div>
                        </el-col>
                    </el-row>
                    <div v-if="totalTableDataCount > ImageList.length">
                        <el-divider>
                            <el-link type="primary" @click="loadMoreImage">加载更多</el-link>
                        </el-divider>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog ref="dialog" :visible.sync="videoShow" width="40vw" append-to-body custom-class="hs-dialog" top="1vh">
            <div id="video-container"></div>

        </el-dialog>
        <plantimage ref="plant"></plantimage>
    </div>
</template>

<script>
import { formatDate } from '@/common/util.js'
import { mapState } from 'vuex'
import EZUIKit from 'ezuikit-js';
import { find, concat } from 'lodash'
import { get } from "@/utils/http";
import documentword from '@/components/document-word'
import config from './config.js'
import plantimage from './platimage'
export default {
    components: { documentword, plantimage },
    data() {
        return {
            showMpdal: false,
            videoShow: false,
            EncoderId: '',
            city: "",
            model: "",
            name: "",
            type: "",
            status: "",
            address: "",
            Encoder: { InternalModel: 'sense' },
            AlarmCount: 0,
            Location: '',
            ImageList: [],
            totalTableDataCount: 0,
            tableCostTime: 0,
            pageRows: 12,
            pageIndex: 1,
            totalPage: 0,
            lineStatus: true,
            queryDate: [
                new Date().getTime() - 3600 * 1000 * 24 * 360,
                new Date().getTime()
            ],
            Imageloading: true,
            selectDayOption: 1,
            EZU: null,
            dayOptions: [
                {
                    value: 1,
                    label: '按天显示'
                },
                {
                    value: 10,
                    label: '间隔10天显示'
                }
            ],
            defaultImg: '../../../assets/icon/default0.png',
            factory: "",

        }
    },

    computed: {
        //  ...mapState(['encoders', 'land']),
        SensorsPicture() {
            let CalcSensor = []
            config.SensorConfig.filter(t => t.Category === '影像监测').forEach(
                (cfg, index) => {
                    CalcSensor.push(Object.assign(cfg, { Install: true }))
                }
            )
            return CalcSensor
        }
    },
    watch: {
        videoShow(val) {
            if (this.EZU && !val) {
                this.EZU.stop();
            }
        }
    },
    mounted() {
        this.EncoderId = this.$route.params.id;
        // this.loadData();
        this.getPicList();
        // this.loadImageData()
        const item = this.$store.state.currentItem;
        if (item) {
            const obj = JSON.parse(item)
            this.model = obj.model;
            this.type = obj.key;
            this.status = obj.online;
            this.address = obj.location.province + obj.location.city
            this.factory = `${obj.location.district ? obj.location.district : ''}${obj.location.town ? obj.location.town : ''}`;
            this.modal = obj.model;
            this.name = obj.name;
        }
    },

    methods: {
        defImg() {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        },
        getPicList() {
            get(`/metrics/snapshot/list?key=${this.EncoderId}&page=${this.pageIndex}&rows=${this.pageRows}`).then(res => {
                if (res.data.rows && res.data.rows.length > 0) {
                    this.totalTableDataCount = res.data.rowTotal;
                    // this.city = res.data.rows[0].device.location.city;
                    // this.model = res.data.rows[0].device.model;
                    // this.name = res.data.rows[0].device.name;
                    // this.type = res.data.rows[0].device.key;
                    // this.status = res.data.rows[0].device.status;
                    // this.address = res.data.rows[0].device.location.province + res.data.rows[0].device.location.city
                    // this.factory = res.data.rows[0].device.location.district + res.data.rows[0].device.location.town;
                    // this.lineStatus = res.data.rows[0].device.online;
                    // const list=[];
                    // for(var key in res.data){
                    //    // console.log("key",key,'value==',res.data[key]);
                    //     const o=find(airParamList,{key:key});
                    //     if(o){
                    //       //  console.log("ooo",o,'==key==',key)
                    //         list.push({label:o.label,value:`${res.data[key]}${o.unit}`, Resource:o.Resource})
                    //          }
                    //     };
                    const list = concat(this.ImageList, res.data.rows)
                    if (list.length !== this.totalTableDataCount) {
                        this.pageIndex = this.pageIndex + 1;
                    }
                    // this.ImageList = res.data.rows;
                    this.ImageList = list;

                }

            })
        },
        loadData() {
            get(`/metrics/video?key=${this.EncoderId}`).then(res => {
                if (res.data && res.data.length == 2) {
                    EZU = new EZUIKit.EZUIKitPlayer({
                        id: 'video-container', // 视频容器ID
                        accessToken: res.data[0],
                        url: res.data[1],
                        // template: "security",
                        footer: ["broadcast", "fullScreen"],
                        // plugin: ['talk'],
                        width: 780,
                        height: 600,
                        handleError: (data) => {
                            //   if (data.retcode === 1003) {
                            //     document.getElementById("video-container-loading-item-0").innerHTML = "";
                            //     setShowResetButton(true)
                            //   }
                            //   //

                        }
                    });
                }


            })
        },
        loadMoreImage() {
            if (this.ImageList.length === this.totalTableDataCount) return;
            this.getPicList()
            // if (this.pageIndex >= this.totalPage) {
            //     return
            // }
            // this.pageIndex++
            // this.loadImageData()
        },
        loadImageData() {
            this.Imageloading = true
            try {
                if (this.pageIndex === 1) {
                    this.ImageList = []
                }
                this.$request('capture', 'day', {
                    rows: this.pageRows,
                    page: this.pageIndex,
                    begindate:
                        this.queryDate == null
                            ? ''
                            : formatDate(
                                this.queryDate[0],
                                'yyyy-MM-dd hh:mm:ss'
                            ),
                    endate:
                        this.queryDate == null
                            ? ''
                            : formatDate(
                                this.queryDate[1],
                                'yyyy-MM-dd hh:mm:ss'
                            ),
                    encoderId: this.EncoderId
                }).then(res => {
                    if (res.code === 1) {
                        this.ImageList = this.ImageList.concat(
                            res.data.rows
                                .filter(
                                    (t, i) => i % this.selectDayOption === 0
                                )
                                .map(t => {
                                    t.Url = t.Url + '?x-oss-process=style/hs'
                                    return t
                                })
                        )
                        this.totalPage = res.data.total
                        this.totalTableDataCount = res.data.records
                        this.tableCostTime = res.data.costtime
                        this.Imageloading = false
                    } else {
                        this.$message.error('加载图片出错了哦')
                        this.Imageloading = false
                    }
                })
            } catch (e) {
                this.Imageloading = false
            }
        },
        viewplant(image) {
            // this.showMpdal=true
            // this.loadData();
            this.$refs.plant.show(this.EncoderId, image.device.key)
        },
        closeModal() {
            this.showMpdal = false;
            this.$refs.plant.closeVideo();
        },
        showVideo() {
            this.videoShow = true;
            const width = document.documentElement.clientWidth * 0.38;
            const height = document.documentElement.clientHeight * 0.5;
            get(`/metrics/video?key=${this.EncoderId}`).then(res => {
                if (res.data && res.data.length == 2) {
                    this.EZU = new EZUIKit.EZUIKitPlayer({
                        id: 'video-container', // 视频容器ID
                        accessToken: res.data[0],
                        url: res.data[1],
                        // template: "security",
                        footer: ["broadcast", "fullScreen"],
                        // plugin: ['talk'],
                        width: width,
                        height: height,
                        handleError: (data) => {
                            //   if (data.retcode === 1003) {
                            //     document.getElementById("video-container-loading-item-0").innerHTML = "";
                            //     setShowResetButton(true)
                            //   }
                            //   //

                        }
                    });
                }


            })
        }

    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}

.color-m09 {
    color: #090e15;
}

.color-m16 {
    color: #162437;
}

.color-m5b {
    color: #5b6580;
}

.color-m27 {
    color: #273447;
}

.color-m1f {
    color: #1f2d3f;
}

.equipm {
    position: relative;
    overflow: hidden;

    .equipm-desc {
        background: url(../../../assets/status/m-3.png) no-repeat;
        background-size: 100% 100%;
        height: 200px;
        padding-left: 25px;
        position: relative;
        z-index: 12;

        .encoder-bg {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 60%;
            z-index: -1;

            &::before {
                content: '';
                display: inline-block;
                width: 100%;
                height: 100%;
                // background: url(../../../assets/encoder/sense.png) no-repeat;
                background-position: right top;
                background-size: 70%;
            }
        }

        .equ-cc {
            height: 200px;
            text-align: left;

            h3 {
                font-weight: bold;
                font-size: 28px;
                color: #fff;
                padding-top: 35px;
                letter-spacing: 2px;
            }

            p {
                margin: 0;
                margin-top: 15px;

                span {
                    display: block;
                    font-size: 16px;
                    color: #fff;
                    line-height: 24px;
                }
            }
        }
    }

    .equipm-status {
        background-color: #fff;
        height: 200px;
        border-radius: 10px;

        .equ-net {
            text-align: center;

            b {
                display: block;
                font-size: 18px;
                color: #273447;
                margin: 10px 0;
                margin-top: 15px;
            }

            span {
                display: block;
                color: #8892a0;
                font-size: 14px;
                min-width: 100px;
            }

            i {
                display: block;
                padding-top: 20px;
            }
        }

        .equ-sensor {
            border-left: solid 1px #f0f0f0;
            margin-top: 21px;
        }

        .equ-alarm {
            height: 200px;
            text-align: center;
            margin: 0;

            .status {
                background: url(../../../assets/status/ll-4.png) no-repeat;
                background-size: 100% 100%;
            }

            .alarm {
                background: url(../../../assets/status/ll-5.png) no-repeat;
                background-size: 100% 100%;
            }

            .location {
                background: url(../../../assets/status/ll-6.png) no-repeat;
                background-size: 100% 100%;
            }

            i {
                display: inline-block;
                width: 48px;
                height: 48px;
                line-height: 48px;
                color: #fff;
                font-size: 42px;
                font-weight: bold;
            }

            span {
                display: block;
                font-weight: bold;
                font-size: 16px;
                color: #fff;
                margin-top: 20px;
            }
        }
    }
}

.sensor-item {
    padding: 10px 10px;
    margin-top: 20px;
    position: relative;

    &:hover {
        background: rgba(176, 185, 210, 0.1);
    }

    &:after {
        content: '';
        position: absolute;
        height: 80%;
        width: 1px;
        top: 10%;
        right: 0px;
        background: #ecf1f9;
    }
}

.image-item {
    position: relative;
    width: calc(100% - 20px);
    height: 140%;
    // width: calc((100% - 60px) / 3);
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    .desc {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        text-align: center;
        font-size: 14px;
    }
}

.queryform {
    vertical-align: middle;

    .el-form-item {
        margin-bottom: 0px;
    }
}

.modal-content {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000000a1;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;

}

.modal-container {
    width: 800px;
    height: 667px;
    background: white;
    padding: 10px;
    position: relative;
}

.close-btn {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 70px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: #00a9ff;
    cursor: pointer;
    border-radius: 5px;
    color: white;
    letter-spacing: 3px;
    font-size: 16px;
}

.out-line {
    background: #cacaca !important;
    border-radius: 12px;
}
</style>
